import { render } from "./AdminBoxDesignMeeting.vue?vue&type=template&id=29bb196b&scoped=true"
import script from "./AdminBoxDesignMeeting.vue?vue&type=script&lang=js"
export * from "./AdminBoxDesignMeeting.vue?vue&type=script&lang=js"

import "./AdminBoxDesignMeeting.vue?vue&type=style&index=0&id=29bb196b&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29bb196b"]])

export default __exports__